import $ from 'jquery';
import 'slick-carousel';

class Stats {
  constructor() {
    $('.stats').each(function() {
      const $slides = $(this).find('.stats__list');
      const $prev = $(this).find('.stats__prev');
      const $next = $(this).find('.stats__next');
      $slides.slick({
        slidesToShow: 5,
        prevArrow: $prev,
        nextArrow: $next,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    });
  }
}

export default Stats;
